/**
 * Conversation Flow Types
 *
 * This file imports the generated Zod schemas and composes them into types.
 *
 * The Zod schemas are generated from JSON Schema, which is generated from Python dataclasses.
 * See apps/agent-server/core/conversation_flow.py for the source of truth.
 */
import { z } from "zod";
import { edgeSchema } from "./generated/edge.generated.js";
import { slotPartSchema } from "./generated/slot-part.generated.js";
import { contentPartSchema } from "./generated/content-part.generated.js";
import { fieldPartSchema } from "./generated/field-part.generated.js";
import { startSectionSchema } from "./generated/start-section.generated.js";
import { exploreSectionSchema as newExploreSectionSchema } from "./generated/explore-section.generated.js";
import { gateSectionSchema as newGateSectionSchema } from "./generated/gate-section.generated.js";
import { messageSectionSchema as newMessageSectionSchema } from "./generated/message-section.generated.js";
import { collectSectionSchema as newCollectSectionSchema } from "./generated/collect-section.generated.js";
import { endSectionSchema } from "./generated/end-section.generated.js";
import { conversationFlowSchema } from "./generated/conversation-flow.generated.js";
// Export schemas
export { edgeSchema, slotPartSchema, contentPartSchema, fieldPartSchema, startSectionSchema, endSectionSchema, conversationFlowSchema, };
// Rename to avoid collision with interview-sections exports
export const flowExploreSectionSchema = newExploreSectionSchema;
export const flowGateSectionSchema = newGateSectionSchema;
export const flowMessageSectionSchema = newMessageSectionSchema;
export const flowCollectSectionSchema = newCollectSectionSchema;
// Create union for flow sections
export const flowSectionSchema = z.discriminatedUnion("section_type", [
    startSectionSchema,
    newExploreSectionSchema,
    newGateSectionSchema,
    newMessageSectionSchema,
    newCollectSectionSchema,
    endSectionSchema,
]);
// Section type constants for the new flow model
export const FLOW_SECTION_TYPES = {
    START: "start",
    EXPLORE: "explore",
    GATE: "gate",
    MESSAGE: "message",
    COLLECT: "collect",
    END: "end",
};
